import { useState, FormEvent } from "react";
import { useNavigate, Link } from "react-router-dom";
import { adminAPI } from "../../services/api";
import ThemeToggle from "../../components/ThemeToggle/ThemeToggle";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      await adminAPI.requestPasswordReset(email);
      setSuccess(true);
    } catch (err: any) {
      setError(
        err.response?.data?.message ||
          "Failed to send reset email. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="forgot-password-page">
        <div className="theme-toggle-wrapper">
          <ThemeToggle floating />
        </div>

        <div className="forgot-password-background">
          <div className="login-shape shape-1"></div>
          <div className="login-shape shape-2"></div>
          <div className="login-shape shape-3"></div>
        </div>

        <div className="forgot-password-container">
          <div className="success-card">
            <div className="success-icon">✅</div>
            <h2>Check Your Email</h2>
            <p>
              If an account exists with <strong>{email}</strong>, you'll receive
              a password reset link shortly.
            </p>
            <p className="hint">
              Please check your inbox and spam folder. The link will expire in
              15 minutes.
            </p>
            <button
              onClick={() => navigate("/admin/login")}
              className="btn-primary"
            >
              Return to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-page">
      <div className="theme-toggle-wrapper">
        <ThemeToggle floating />
      </div>

      <div className="forgot-password-background">
        <div className="login-shape shape-1"></div>
        <div className="login-shape shape-2"></div>
        <div className="login-shape shape-3"></div>
      </div>

      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <div className="card-header">
            <div className="icon-wrapper">
              <span className="icon">🔑</span>
            </div>
            <h1>Forgot Password?</h1>
            <p>
              Enter your email address and we'll send you a link to reset your
              password.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="forgot-password-form">
            {error && (
              <div className="alert alert-error">
                <span className="alert-icon">⚠️</span>
                <span>{error}</span>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <div className="input-wrapper">
                <span className="input-icon">📧</span>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@learnandinnovatespace.com"
                  required
                  disabled={isLoading}
                  autoComplete="email"
                  autoFocus
                />
              </div>
            </div>

            <button type="submit" className="btn-submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="spinner"></span>
                  <span>Sending...</span>
                </>
              ) : (
                <>
                  <span>Send Reset Link</span>
                  <span className="btn-arrow">→</span>
                </>
              )}
            </button>

            <div className="form-footer">
              <Link to="/admin/login" className="link-back">
                ← Back to Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
